



















import editForm from '@/activeForms/wiki/editPage'
import Vue from 'vue'
import _ from 'lodash'
import wikiPageModel from '@/models/wiki/wikiPage'
export default Vue.extend({
  props: {
    id: String
  },
  data () {
    return {
      data: {},
      editForm
    }
  },
  methods: {
    onCreated () {
      this.$message({
        // @ts-ignore
        message: this.$t('wiki.single_node_changed'),
        type: 'success'
      });
      // this.loadPage()
      this.$router.push({name: 'wikiPage', params: {id: this.id}})
    },
    onError () {
      // @ts-ignore
      this.$message({
        // @ts-ignore
        message: this.$t('labels.error'), type: 'error'});
    },
    async loadPage () {
      await this.$store.dispatch('wiki/getPage', this.id)
      this.setData();
    },
    setData () {
      this.data = _.cloneDeep(this.wikiPage.getData())
    },
  },
  computed: {
    wikiPage (): wikiPageModel {
      return this.$store.state.wiki.pages[this.id]
    }
  },
  async mounted () {
    await this.loadPage()
  }
})
